import React, { Component } from 'react';
import PropTypes from 'prop-types';
import CampaignDays from '../modules/campaign-days';
import BarPercent from '../modules/bar-percent';

export default class CampaignBoxUserResume extends Component{
  getTitle(){
    const { campaign, showTitle } = this.props;
    let total = campaign.get('clientes');
    let completed = campaign.get('clientes_contactados');
 
   
    let chanelIcon = '';
    if(campaign.get('canales') == "whatsapp"){
      chanelIcon = 'whatsapp';
    }
    if(campaign.get('canales') == "sms"){
      chanelIcon = 'sms';
    }
    if(campaign.get('canales') == "email"){
      chanelIcon = 'email';
    }
    if(campaign.get('canales') == "voz"){
      chanelIcon = 'voz';
    }

    if(!showTitle){ return null; }

    return (
      <span>
        <i className={`icon-element clients inline-left`}></i>
        {/* {campaign.get('clientes')} Clientes */}
        { completed + '/'+ total  + " " + " Contactos"}
        <i className={`${chanelIcon}`}></i>
        
      </span>
      
    );
  }
  render(){
    const { campaign, wrapper } = this.props,
          title = this.getTitle();
  let   fechaTerminoEnvio = new Date(campaign.get('ultim_fecha_enviado'));
  let hora = fechaTerminoEnvio.getHours();
  let minutos = fechaTerminoEnvio.getMinutes();
  const minutosFormateados = minutos.toString().padStart(2, '0');
  let horaFormateada = `${hora}:${minutosFormateados}`;
  

    return(
      <div className={`${ wrapper ? 'campaign-box-wrapper' : '' }`}>
        <div className="campaign-client-visualization-holder active">
          <span className="campaign-client-visualization-header">
            { title }
            <BarPercent total={campaign.get('clientes')} sendEnd={horaFormateada}completed={ campaign.get('enviado')} stateCampaign ={campaign.get('estado_campana')} campaing ={campaign}/>
          </span>
          {/* <CampaignDays days={campaign.get('dias_envio')} additionalHolderClass={'align-center'} /> */}
        </div>
      </div>
    );
  }
}

CampaignBoxUserResume.propTypes = {
  campaign: PropTypes.object,
  wrapper: PropTypes.bool,
  showTitle: PropTypes.bool
}

CampaignBoxUserResume.defaultProps = {
  wrapper: true,
  showTitle: true
}
